module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"item":"1 item | {n} items"}}')
  delete Component.options._Ctor
}
